import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { SsrModule } from 'app/constants/ssrModules';

import Container, { ContainerProps } from '../../components/Container';
import { activeLevel } from '../../selectors/prematch';

const mapStateToProps = (state: ReduxState): ContainerProps => ({
  activeLevel: activeLevel(state),
  ssrDataId: SsrModule.LEFT_MENU_PREMATCH,
});

export default connect(mapStateToProps)(Container);
